var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5L3 3.75V8.3175C3 12.105 5.5575 15.6375 9 16.5C12.4425 15.6375 15 12.105 15 8.3175V3.75L9 1.5ZM8.205 11.655L5.55 9L6.6075 7.9425L8.1975 9.5325L11.3775 6.3525L12.435 7.41L8.205 11.655Z",
    fill: "#2C62F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateChecked);
export default __webpack_public_path__ + "static/media/certificate-checked.fb63183ae4bf9657adafb4623f4b57e0.svg";
export { ForwardRef as ReactComponent };